import { useState, useEffect } from 'react';
import { fetchPartners } from '../services/strapi';
import ImageCarousel from './ImageCarousel';
const PartnersList = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getPartners = async () => {
      try {
        setLoading(true);
        const data = await fetchPartners();
        setPartners(data); 
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getPartners();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  return (
    <div className="partners-grid">
         <ImageCarousel 
      partnerMedia={partners.partnerMedia}
      autoPlay={true}
      interval={5000}
    />
    </div>
  );
};

export default PartnersList;
